import { useMutation } from '@apollo/client';
import { deleteWishList } from '../../graphql/mutations/wishlistMutations';

export const useDeleteWishlist = () => {
  const [deleteWishlistMutation, { loading, error }] = useMutation(deleteWishList, {
    refetchQueries: ['WishListsByUserID'],
    awaitRefetchQueries: true
  });

  const sanitizeInput = (input = {}) => {
    const cleaned = { ...input };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === undefined) {
        delete cleaned[key];
      }
    });
    return cleaned;
  };

  const handleWishlistDeletion = async (wishlistId) => {
    try {
      if (!wishlistId) {
        throw new Error('Wishlist ID is required');
      }

      const input = sanitizeInput({ id: wishlistId });

      const { data: wishlistResponse } = await deleteWishlistMutation({
        variables: { input }
      });

      return wishlistResponse?.deleteWishList;
    } catch (error) {
      console.error('Error deleting wishlist:', error);
      throw error;
    }
  };

  return {
    handleWishlistDeletion,
    loading,
    error
  };
};